import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import React, { useEffect, useState, Suspense } from "react";

export default function FloorGuide(props) {
  const floorList = props.floorList;
  const [expanded, setExpanded] = useState("");
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <>
      <div className="board-list board-list-floor">
        {floorList &&
          floorList.map((item, i) => (
            <Accordion
              key={i}
              expanded={expanded === `panel${i}`}
              onChange={handleChange(`panel${i}`)}
              className="item"
            >
              <AccordionSummary
                aria-controls={`panel${i}d-content`}
                id={`panel${i}d-header`}
              >
                <div className="floor-num">{item.flr}</div>
                <div className="tit">{item.flrDesc}</div>
              </AccordionSummary>
              <AccordionDetails>
                {item.storeEnteringByFloorList.map((detailItem, i) => (
                  <div className="floor-item" key={i}>
                    <p>{detailItem.nm}</p>
                    <div className="board-info">
                      <span className="date">{detailItem.tm}</span>
                      <span className="place">{detailItem.tel}</span>
                    </div>
                  </div>
                ))}
              </AccordionDetails>
            </Accordion>
          ))}
      </div>
    </>
  );
}
